import { render, staticRenderFns } from "./LoadingLayout.vue?vue&type=template&id=31f2c1d6&scoped=true&"
import script from "./LoadingLayout.vue?vue&type=script&lang=js&"
export * from "./LoadingLayout.vue?vue&type=script&lang=js&"
import style0 from "./LoadingLayout.vue?vue&type=style&index=0&id=31f2c1d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f2c1d6",
  null
  
)

export default component.exports